import { Paper, Stack } from '@mui/material';
import { ReactNode } from 'react';

export interface ViewerToolbarProps {
  children: ReactNode;
}

export const ViewerToolbar = ({ children }: ViewerToolbarProps) => (
  <Stack
    component={Paper}
    variant="outlined"
    direction="row"
    alignItems="center"
    spacing={1}
    sx={{ alignSelf: 'center', my: 3, px: 2, py: 1 }}>
    {children}
  </Stack>
);
